export const GET_COURSE_FLASH_CARD_LIST_SUCCESS = 'GET_COURSE_FLASH_CARD_LIST_SUCCESS';
export const LOADING_MESSAGE = '加载中...';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
